export interface NameableItem {
  localizedNameDesc?: Record<string, string>;
  nameDesc?: string;
  skuCategory?: string;
}

/**
 * Base package name with the dynamic suffix removed.
 * e.g. 'Value - Deluxe' → 'Value'
 * Only strips when skuCategory is 'PACKAGE' and nameDesc contains '-'.
 */
export const stripDynamicPackageName = (item?: NameableItem): string => {
  if (item?.skuCategory === 'PACKAGE' && item.nameDesc?.includes('-')) {
    return item.nameDesc.split('-')[0].trim();
  }
  return item?.nameDesc ?? '';
};

/**
 * Returns the best display name for an item given the current locale.
 * locale is a full BCP-47 tag ('fr-ca'); matching is on the language prefix only ('fr').
 * Falls back to stripDynamicPackageName when no localised match is found.
 */
export const getItemDisplayName = (item: NameableItem | undefined, locale: string): string => {
  const lang = locale.slice(0, 2);
  const localized = Object.entries(item?.localizedNameDesc ?? {}).find(([l]) => l.slice(0, 2) === lang);
  return localized?.[1] ?? stripDynamicPackageName(item);
};
